(function () {
console.log('discount-abtest.js loaded');

const LOGIN_AUTO_DISCOUNT_KEY = 'loginAutoDiscount';
const LOGIN_AUTO_DISCOUNT_MAX_AGE = 7 * 24 * 60 * 60 * 1000;

try {
  const storedLoginDiscount = JSON.parse(localStorage.getItem(LOGIN_AUTO_DISCOUNT_KEY) || 'null');
  const storedAt = Number(storedLoginDiscount?.createdAt);
  const isExpired =
    !storedLoginDiscount?.code ||
    !Number.isFinite(storedAt) ||
    storedAt > Date.now() ||
    Date.now() - storedAt >= LOGIN_AUTO_DISCOUNT_MAX_AGE;

  if (storedLoginDiscount && isExpired) {
    if (localStorage.getItem('autoCode') === storedLoginDiscount.code) {
      localStorage.removeItem('autoCode');
    }
    localStorage.removeItem(LOGIN_AUTO_DISCOUNT_KEY);
  } else if (storedLoginDiscount?.redirectPending) {
    const customerId = document.querySelector('#customer_id')?.value;
    const currentPath = window.location.pathname.replace(/\/$/, '');
    const isSocialLoginDestination =
      currentPath === '/account' ||
      currentPath === '/account/login' ||
      currentPath === '/pages/dashboard';

    if (customerId && isSocialLoginDestination) {
      storedLoginDiscount.redirectPending = false;
      localStorage.setItem(LOGIN_AUTO_DISCOUNT_KEY, JSON.stringify(storedLoginDiscount));
      window.location.replace('/pages/explore');
      return;
    }
  }
} catch (error) {
  localStorage.removeItem('autoCode');
  localStorage.removeItem(LOGIN_AUTO_DISCOUNT_KEY);
}

let currentCode = localStorage.getItem('autoCode');
if(!currentCode || currentCode.includes('20WELCOMEMEALS') || currentCode === '20FIRSTORDER') {
  // AB test concluded - everyone gets 10% off by default
  let defaultCode = '10WELCOMEMEALS';
  localStorage.setItem('autoCode', defaultCode);
  
  // Set PostHog person property for conversion tracking
  if (window.posthog) {
    posthog?.people?.set({
      discount_code_ab_test: defaultCode
    });
  }
}
})();
